import moment from 'moment'
import 'moment-timezone'
import {
  DATE_INPUT_CONSTANTS,
  DATE_PICKER_CONSTANTS,
  DATE_PICKER_INTERACTIVE_SELECTORS,
  MANUAL_DATE_TIME_INPUT_FORMATS,
} from './constants'

export const getDatePickerIconSelector = (uniqueString: string) =>
  `.${DATE_PICKER_CONSTANTS.CUSTOM_ICON_CLASS_PREFIX}${uniqueString}`

export const shouldKeepDatePickerOpenOnOutsideClick = (
  target: HTMLElement,
  calendarIconSelector: string
): boolean => {
  if (target.closest(calendarIconSelector)) {
    return true
  }
  return !!target.closest(DATE_PICKER_INTERACTIVE_SELECTORS)
}

export const resolveDatePickerMinMax = (min?: string, max?: string) => ({
  minDate: min ? new Date(min) : new Date(DATE_INPUT_CONSTANTS.MIN_DATE),
  maxDate: max ? new Date(max) : new Date(DATE_INPUT_CONSTANTS.MAX_DATE),
})

export const parseDatePickerSelectedValue = (
  value: string | null | undefined,
  format: string
): Date | null => {
  if (!value) return null
  const parsed = moment(value, format, true)
  return parsed.isValid() ? parsed.toDate() : null
}

export const formatDatePickerChangeValue = (
  date: Date,
  includeTime?: boolean
): string => {
  if (includeTime) {
    return moment(date).format(DATE_INPUT_CONSTANTS.COMMON_DATE_TIME_FORMAT_2)
  }
  return moment(date).format(DATE_INPUT_CONSTANTS.DATE_FORMAT_API)
}

export const parseDateTimePickerValueInTz = (
  value: string | null | undefined,
  timeZone: string
): Date | null => {
  if (!value) return null
  const parsed = moment.tz(value, timeZone)
  return parsed.isValid() ? parsed.toDate() : null
}

export const formatDateTimePickerChangeAsUtcIso = (
  date: Date,
  timeZone: string
): string => moment.tz(date, timeZone).utc().toISOString()

export const parseManualDateTimeInput = (
  rawValue: string,
  timeZone: string
): string | null => {
  const trimmed = rawValue.trim()
  if (!trimmed) return null

  const parsed = moment(trimmed, MANUAL_DATE_TIME_INPUT_FORMATS, true)
  if (!parsed.isValid()) return null
  return parsed.tz(timeZone, true).utc().toISOString()
}

export const getDatePickerTimeBounds = (
  value: string | null | undefined,
  minDate: Date,
  maxDate: Date
): { minTime?: Date; maxTime?: Date } => {
  if (!value) return {}
  const minTime = moment(value).isSame(minDate, 'day')
    ? minDate
    : moment().startOf('day').toDate()
  const maxTime = moment(value).isSame(maxDate, 'day')
    ? maxDate
    : moment().endOf('day').toDate()
  return { minTime, maxTime }
}

export const formatFormDateOnlyDisplayValue = (
  value: string | null | undefined
): string | null =>
  value ? moment(value).format(DATE_INPUT_CONSTANTS.COMMON_DATE_FORMAT) : null
